import { render, staticRenderFns } from "./NewsPostMain.vue?vue&type=template&id=53277eb4&"
import script from "./NewsPostMain.vue?vue&type=script&lang=js&"
export * from "./NewsPostMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports